<nz-table
  [nzData]="filteredData"
  [nzBordered]="true"
  [nzSize]="'middle'"
  [nzShowPagination]="false"
  [nzScroll]="{ x: '100%' }"
>
  <thead>
  <tr>
    <th nzWidth="40px">#</th> <!-- Nueva columna para numeración -->
    <th *ngFor="let col of columns" nzWidth="120px">
      {{ col.title }}
    </th>
    <th nzWidth="120px">Acciones</th>
  </tr>
  </thead>

  <tbody>
  <tr *ngFor="let row of filteredData; let i = index">
    <td>{{ getRowNumber(i) }}</td> <!-- Mostrar número de fila -->
    <td *ngFor="let col of columns">
      <!-- Directamente insertamos el Tag si la columna es 'estado' -->
      <app-tag *ngIf="col.key === 'estado'"
               [text]="row[col.key]"
               [color]="row.estado === 'Pagado' ? 'red' : 'default'">
      </app-tag>

      <!-- Para el resto de las columnas, mostramos el valor normal -->
      <span *ngIf="col.key !== 'estado'">
          {{ getValue(row, col.propertyPath || [col.key]) }}
        </span>
    </td>
    <td class="table-cell">
      <button class="action-button" *ngIf="showEditButton" nz-button nzType="default" (click)="onEdit(row)">
        <nz-icon nzType="edit"></nz-icon>
      </button>
      <button class="action-button" *ngIf="showDeleteButton" nz-button nzType="default" (click)="onDelete(row)">
        <nz-icon nzType="delete"></nz-icon>
      </button>
      <button class="action-button" *ngIf="showCheckButton" nz-button nzType="default" (click)="checkItem(row)">
        <nz-icon nzType="check"></nz-icon>
      </button>
    </td>
  </tr>
  </tbody>
</nz-table>
<nz-pagination
  [nzPageIndex]="pageIndex"
  [nzTotal]="length"
  [nzPageSize]="pageSize"
  (nzPageIndexChange)="onPageChange($event)">
</nz-pagination>
